/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileFormatCategoryChange } from './FileFormatCategoryChange';
import {
    FileFormatCategoryChangeFromJSON,
    FileFormatCategoryChangeFromJSONTyped,
    FileFormatCategoryChangeToJSON,
} from './FileFormatCategoryChange';

/**
 * 
 * @export
 * @interface ListFileformatCategoryChangesResponseBody
 */
export interface ListFileformatCategoryChangesResponseBody {
    /**
     * 
     * @type {Array<FileFormatCategoryChange>}
     * @memberof ListFileformatCategoryChangesResponseBody
     */
    items: Array<FileFormatCategoryChange>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListFileformatCategoryChangesResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListFileformatCategoryChangesResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListFileformatCategoryChangesResponseBody interface.
 */
export function instanceOfListFileformatCategoryChangesResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListFileformatCategoryChangesResponseBodyFromJSON(json: any): ListFileformatCategoryChangesResponseBody {
    return ListFileformatCategoryChangesResponseBodyFromJSONTyped(json, false);
}

export function ListFileformatCategoryChangesResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListFileformatCategoryChangesResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FileFormatCategoryChangeFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListFileformatCategoryChangesResponseBodyToJSON(value?: ListFileformatCategoryChangesResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(FileFormatCategoryChangeToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

